"use client";

import { useMatomoPageTracking } from "@/utils/matomo";

export default function MatomoTrackingProvider() {
  useMatomoPageTracking();
  return <div id="matomo-id"></div>;
}
